import { useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { EBanners } from '../../../constants/banners';
import { selectMapBounds } from '../../../selectors/mapBounds';
import { selectJsonQuery, selectResults } from '../../../selectors/results';
import { isFSKBannerAvailable } from '../../../utils/bannerPackages';

export function useGetFskBanner(proPlusBannerType: EBanners.ProPlus | null): EBanners | null {
  const deviceType = useDeviceType();
  const jsonQuery = useSelector(selectJsonQuery);
  const results = useSelector(selectResults);
  const { zoom } = useSelector(selectMapBounds);
  const isDesktop = deviceType === 'desktop';

  // Отображать ли фск баннер в качестве заглушки, когда нет промо баннеров ЖК
  const isShowWithPromoBannerOnMobile = !proPlusBannerType && !isDesktop;

  const isFSKAvailable = isFSKBannerAvailable({
    jsonQuery,
    deviceType,
    subdomain: results.subdomain,
    isShowWithPromoBannerOnMobile,
    zoom,
  });

  if (isFSKAvailable) {
    return EBanners.Fsk;
  }

  return null;
}
